/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import upperFirst from 'lodash/upperFirst';

import { gridSize } from '@atlaskit/theme/constants';

import groupedTokens from './grouped-tokens';

import SubGroup from './components/subgroup';

export const listStyleReset = css({
  listStyle: 'none',
  margin: 0,
  padding: 0,
});

export const listItemStyleReset = css({
  marginTop: 0,
  marginBottom: 0,
});

const ColorPaletteRamps = () =>
  groupedTokens.length > 0 && (
    <ul css={listStyleReset}>
      {groupedTokens.map((group) => (
        <li
          key={group.name}
          css={{
            marginBottom: gridSize() * 5,
          }}
        >
          {group.name && group.name !== 'colors' && (
            <h3 css={{ marginBottom: gridSize() * 2 }}>
              {upperFirst(group.name)}
            </h3>
          )}
          {group.subgroups.length > 0 && <SubGroup {...group} />}
        </li>
      ))}
    </ul>
  );

export default ColorPaletteRamps;
